/**
 * Updates the post data of the condition
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The unique code of the integration
 * @param {String} options.conditionCode   The unique code of the condition
 * @param {Object} options.updates         The properties to update
 * @return {undefined}
 */
const updateConditionPostData = ( { integrationCode, conditionCode, updates = {} } ) => {
	// Update the data
	/* eslint-disable-next-line max-len */
	UncannyAutomator.integrations[ integrationCode ].conditions.available[ conditionCode ] = Object.assign( UncannyAutomator.integrations[ integrationCode ].conditions.available[ conditionCode ], updates );
}

export default updateConditionPostData;
